module.exports = __webpack_public_path__ + "static/media/welcome.cc9a42ee.png";